import Buttons from './buttons';
import PaymentMethods from './payment-methods';

export default {
  Buttons,
  PaymentMethods,
};
